import { debugMode } from "./debug"

const base_url = (debugMode) ? "http://127.0.0.1:5000" : "https://hisacademyoh.com";
const admin_base_url = (debugMode) ? "http://127.0.0.1:8081" : "https://admin.hisacademyoh.com";

export { base_url, admin_base_url }